<template>
  <div class="wrapper">
      <simplert></simplert>
      <!-- <div class="loading">
          <div class="loading-img">
              <img src="static/images/walk.gif" alt="">
          </div>
      </div> -->
      <router-view v-show="isInternet"/>
      <Internet v-show="!isInternet"/>
      <div class="use-cookies">
          <div class="container">
              <div class="row">
                  <div class="col-sm-8">
                      <div class="row">
                          <div class="col-sm-4">
                              <img src="static/images/logo-svg.svg" class="img-fluid mt-4" alt="">
                          </div>
                          <div class="col-sm-8">
                              <h5>This website uses cookies</h5>
                              <p>We use cookies to personalize content and ads, to provide social media features and to analyze
                                  our traffic. You consent to our cookies if you continue to use our website. </p>
                          </div>
                      </div>
                  </div>
                  <div class="col-sm-4 text-center">
                      <button class="btn btn-primary cookies-btn" v-on:click="closeCookieAlert()">Ok</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Config from './config'
import Internet from './Internet'

if (Config.IsMobile) {
  require('../static/js/mobile/custom')
} else {
  require('../static/js/web/custom')
}
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      isInternet : true
    }
  },
  beforeCreate () { },
  mounted () {
    window.addEventListener('offline', function(event){
      this.isInternet = false
    }.bind(this));
    window.addEventListener('online', function(event){
      this.isInternet = true
    }.bind(this));
    let i = 0
    let j = false
    let tmt = setInterval(function () {
      if (this.$WebViewBridge && !j) {
        this.$WebViewBridge.onMessage = function (data) {
          let response = JSON.parse(data)
          if (response.type === 'paymentSuccess') {
            this.$root.$emit('paymentSuccess', response.data)
          }
          j = true
          clearInterval(tmt)
        }.bind(this)
      }
      if (i > 31) {
        clearInterval(tmt)
      }
      i++
    }.bind(this), 1000)

    this.$root.$on('isOffline', (bookTest) => {
      this.isInternet = false
    })
  },
  created () {
    // if(!this.$localStorage.get('cookieAlert')) {
    //   setTimeout(function () {
    //     $('.use-cookies').css('bottom', '0%');
    //     this.$localStorage.set('cookieAlert', true, 1000*60*24)
    //   }.bind(this), 3000);
    // }
  },
  components : {
    Internet
  },
  methods : {
    closeCookieAlert : function () {
        $('.use-cookies').css('bottom', '-100%');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue